import {
  Badge,
  StatusBadge,
  type StatusBadgeProps,
} from '@vrplatform/components';
import { useTeam } from '@vrplatform/data';
import type { ThemeColor } from '@vrplatform/theme';

type SharedStatusBadgeProps = {
  badgeStatus: StatusBadgeProps['status'];
  color: ThemeColor;
  label: string;
};

export const SharedStatusBadge = ({
  badgeStatus,
  color,
  label,
}: SharedStatusBadgeProps) => {
  const [{ isGL }] = useTeam();

  if (!label) return null;
  if (isGL) return <StatusBadge label={label} status={badgeStatus} />;

  return <Badge color={color}>{label}</Badge>;
};
